import React, { useState } from 'react';
import { ConditionalRendering } from '@components/common/conditional-rendering';
import MediaForm from './MediaForm';
import MediaContent from './MediaContent';
import { ContentIds } from './constants/media.interface';
import { StyledContainer } from './constants/media.styled';

const MediaAccessContainer = () => {
    const [contentData, setContentData] = useState({id: ContentIds.MEDIA_FORM, props: {}});
    return (
        <StyledContainer className="gi-panel" data-testid="media-access-container">
            <ConditionalRendering isTrue={contentData.id === ContentIds.MEDIA_FORM}>
                <MediaForm setContentData={setContentData} />
            </ConditionalRendering>
            <ConditionalRendering isTrue={contentData.id === ContentIds.DISPLAY_MEDIA}>
                <MediaContent contentData={contentData} setContentData={setContentData} />
            </ConditionalRendering>
        </StyledContainer>
    );
};

export default MediaAccessContainer;